<template>
  <div>
    <div class="goodsManageSet">
      <div class="banner">
        <img src="../../../assets/images/banner3.png" alt="" />
      </div>
      <div class="breadcrumb flex-rowc">
        <div class="breadcrumb_icon">
          <i class="iconfont icon-shangpinsku"></i>
        </div>
        <div class="breadcrumb_item">物流&订单管理</div>
        <div class="breadcrumb_item_arrow"></div>
        <div class="breadcrumb_item">编辑订单支付收款管理</div>
      </div>

      <div class="main_content">
        <div class="block">
          <h1>编辑订单支付收款管理</h1>
        </div>
        <div class="block">
          <h1><span class="mark">*</span>付款方式：</h1>
          <div class="radio_box">
            <van-radio-group
              v-model="formData.paytype"
              style="justify-content: space-evenly"
              :disabled="formData.id != ''"
            >
              <van-radio name="微信" style="margin-bottom: 15px"
                >微信</van-radio
              >
              <van-radio name="支付宝" style="margin-bottom: 15px"
                >支付宝</van-radio
              >
              <van-radio name="第三方支付工具" style="margin-bottom: 15px"
                >第三方支付工具</van-radio
              >
              <van-radio name="银行转账" style="margin-bottom: 15px"
                >银行转账</van-radio
              >
              <van-radio name="数字人民币" style="margin-bottom: 15px"
                >数字人民币</van-radio
              >
              <van-radio name="现金支付">现金支付</van-radio>
            </van-radio-group>
          </div>
        </div>
        <div class="block">
          <h1><span class="mark">*</span>付款金额</h1>
          <div class="input_box">
            <van-field
              v-model="formData.paynum"
              placeholder="输入付款金额"
              @focus="inputFocus"
              @blur="inputBlur"
              @input="handleBlurPrice"
              :readonly="formData.id != ''"
            />
          </div>
        </div>
        <div
          class="block"
          v-if="
            formData.paytype == '银行转账' ||
            formData.paytype == '数字人民币' ||
            formData.paytype == '第三方支付工具' ||
            formData.paytype == '现金支付'
          "
        >
          <h1><span class="mark">*</span>付款抬头</h1>
          <div class="input_box">
            <van-field
              v-model="formData.headname"
              placeholder="输入付款抬头"
              @focus="inputFocus"
              @blur="inputBlur"
              :readonly="formData.id != ''"
            />
          </div>
        </div>
        <div class="block" v-if="formData.paytype == '银行转账'">
          <h1><span class="mark">*</span>付款开户行</h1>
          <div class="input_box">
            <van-field
              v-model="formData.bankname"
              placeholder="输入付款开户行"
              @focus="inputFocus"
              @blur="inputBlur"
              :readonly="formData.id != ''"
            />
          </div>
        </div>
        <div
          class="block"
          v-if="
            formData.paytype == '微信' ||
            formData.paytype == '支付宝' ||
            formData.paytype == '银行转账'
          "
        >
          <h1><span class="mark">*</span>付款账号</h1>
          <div class="input_box">
            <van-field
              v-model="formData.bankaccount"
              placeholder="输入付款账号"
              @focus="inputFocus"
              @blur="inputBlur"
              :readonly="formData.id != ''"
            />
          </div>
        </div>
        <div class="block">
          <h1>
            <span class="mark">*</span>付款凭证截图
            <span class="mark">JPG或PNG文件，大小限制2MB</span>
          </h1>
          <div class="upload_box flex-rowc">
            <template v-if="formData.shotcut">
              <van-image
                width="100%"
                height="100%"
                fit="cover"
                :src="formData.shotcut"
              />
              <div class="del-icon" @click="handleDelImg(1)">
                <van-icon name="delete-o" />
              </div>
            </template>
            <div class="no flex-rowc" v-else>
              <van-icon name="plus" size="50px" color="#ccc" />
              <input
                type="file"
                class="uploadInput"
                ref="fileInput1"
                multiple="multiple"
                accept="image/png,image/jpeg,image/jpg"
                @change="handleChooseImg(1)"
              />
            </div>
          </div>
        </div>

        <div class="block">
          <h1><span class="mark">*</span>付款记录审核状态</h1>
          <div class="radio_box">
            <van-radio-group
              v-model="formData.checkstate"
              style="justify-content: space-evenly"
              :disabled="type == 1"
            >
              <van-radio name="待审核" style="margin-bottom: 15px"
                >待审核</van-radio
              >
              <van-radio name="已审核" style="margin-bottom: 15px"
                >已审核</van-radio
              >
              <van-radio name="审核驳回">审核驳回</van-radio>
            </van-radio-group>
          </div>
        </div>
        <div class="block" v-if="formData.checkstate == '审核驳回'">
          <h1><span class="mark">*</span>驳回原因</h1>
          <div class="textarea_box">
            <van-field
              type="textarea"
              v-model="formData.checkdetail"
              placeholder="输入驳回原因"
              @focus="inputFocus"
              @blur="inputBlur"
              :readonly="type == 1"
            />
          </div>
        </div>
      </div>

      <div class="primary-button" @click="query" v-if="formData.id == '' && type == 1">
        确认
      </div>
      <div class="primary-button" @click="query" v-if="type == 2">保存</div>

      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i>返回
      </div>
    </div>
  </div>
</template>

<script>
import { encryptstringview, uploadPosterImage } from "../../../api/api";
import {
  getOrderListDetail,
  getOrderPaymentDetail,
  addOrderPayment,
  editOrderPayment,
} from "../../../api/shop";
import { mapState } from "vuex";
export default {
  name: "cPaymentDetail",
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_API,
      isShowStyle: false,
      scrollTop: 0,
      isShowType: 1,
      formData: {
        id: "",
        orderno: "",
        paytype: "",
        headname: "",
        bankname: "",
        bankaccount: "",
        paynum: "",
        paytotal: "",
        remain: "",
        shotcut: "",
        createuser: "",
        checkstate: "待审核", // 付款记录审核状态 =待审核 已审核 审核驳回
        checkdetail: "", // 驳回原因
        checkuser: "",
      },
      dataItem: "",
      orderId: "",
      orderOpenid: "",
      type: "", //
      USERINFO: "",
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { orderno, id, orderId, orderOpenid, type } = JSON.parse(
          res.jsondata
        );
        this.orderId = orderId;
        this.orderOpenid = orderOpenid;
        this.formData.orderno = orderno;
        this.type = type;
        if (id != "") {
          this.formData.id = id;
          this.getOrderPaymentDetail(id);
        }

        this.getOrderListDetail(orderId, orderOpenid);
      } else {
        this.$router.back();
      }
    },

    // 获取详情
    getOrderPaymentDetail(id) {
      getOrderPaymentDetail({ id }).then((res) => {
        this.detail = res;
        this.formData.id = res.id;
        this.formData.paytype = res.paytype;
        this.formData.headname = res.headname;
        this.formData.bankname = res.bankname;
        this.formData.bankaccount = res.bankaccount;
        this.formData.paynum = res.paynum;
        this.formData.paytotal = res.paytotal;
        this.formData.remain = res.remain;
        this.formData.createuser = res.createuser;
        this.formData.checkstate = res.checkstate ? res.checkstate : "";
        this.formData.checkdetail = res.checkdetail ? res.checkdetail : "";
        this.formData.checkuser = res.checkuser ? res.checkuser : "";
        this.formData.shotcut = res.shotcut ? res.shotcut : "";
      });
    },

    // 订单列表
    getOrderListDetail(id, openid) {
      let params = {
        openid: openid,
        orderid: id,
      };
      this.loading = true;
      getOrderListDetail(params).then((res) => {
        let newObj = res[0];
        // this.formData.paynum = newObj.price;
        this.formData.paytotal = newObj.price_original;
        // this.formData.remain = newObj.diffrentprice;
        this.loading = false;
      });
    },

    // 获得焦点
    inputFocus(e) {
      this.scrollTop = "-" + (e.srcElement.getBoundingClientRect().top - 200);
      this.isShowStyle = true;
    },
    // 失去焦点
    inputBlur() {
      this.isShowStyle = false;
    },
     // 价格输入失去焦点
    handleBlurPrice() {
      let { paynum } = this.formData;
      let newPrice = paynum.replace(/^(\d*(?:\.\d{0,2})?).*$/, "$1");
      this.formData.paynum = newPrice;
      // this.formData.remain = calculator(paytotal)
      //   .subtract(Number(newPrice))
      //   .toNumber();
    },

    // 上传图片
    handleChooseImg(uploadType) {
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      const formData = new FormData();
      if (uploadType == 1) {
        if (this.verificationPicFile(this.$refs.fileInput1.files)) {
          formData.append("imgfile", this.$refs.fileInput1.files[0]);
        } else {
          this.formData.shotcut = "";
          return;
        }
      }
      uploadPosterImage(formData).then((res) => {
        if (res.result) {
          if (uploadType == 1) {
            this.formData.shotcut = res.url;
          }
          toast.clear();
        } else {
          this.$toast.fail("上传失败");
        }
      });
    },
    // 图片大小限制
    verificationPicFile(file) {
      var fileSize = 0;
      var fileMaxSize = 1024 * 5; //5M
      if (file) {
        fileSize = file[0].size;
        var size = fileSize / 1024;
        if (size > fileMaxSize) {
          this.$toast("上传失败，图片文件大小超过限制！");
          return false;
        } else if (size <= 0) {
          this.$toast("文件大小不能为0M！");
          return false;
        } else {
          if (
            file[0].type != "image/png" &&
            file[0].type != "image/jpg" &&
            file[0].type != "image/jpeg"
          ) {
            this.$toast(
              "上传失败，文件格式不符合标准，仅限JPG、JPEG或PNG图片文件！"
            );
            return false;
          } else {
            return true;
          }
        }
      } else {
        return false;
      }
    },

    // 删除图
    handleDelImg(type) {
      if (type == 1) {
        this.formData.shotcut = "";
      }
    },

    // 保存
    query() {
      let { formData, type, USERINFO } = this;
      if (formData.paytype == "") {
        this.$toast("请选择付款方式");
        return;
      }
      if (formData.paynum == "") {
        this.$toast("请输入付款金额");
        return;
      }
      if (
        formData.paytype == "银行转账" ||
        formData.paytype == "数字人民币" ||
        formData.paytype == "第三方支付工具" ||
        formData.paytype == "现金支付"
      ) {
        if (formData.headname == "") {
          this.$toast("请输入付款抬头");
          return;
        }
      }
      if (formData.paytype == "银行转账") {
        if (formData.bankname == "") {
          this.$toast("请输入付款开户行");
          return;
        }
      }

      if (
        formData.paytype == "微信" ||
        formData.paytype == "支付宝" ||
        formData.paytype == "银行转账"
      ) {
        if (formData.bankaccount == "") {
          this.$toast("请输入付款账号");
          return;
        }
      }

      if (type == 2) {
        this.formData.checkuser = USERINFO.truename;
        if (formData.checkstate === "") {
          this.$toast("请选择付款记录审核状态");
          return;
        }
        if (formData.checkstate == "审核驳回" && formData.checkdetail == "") {
          this.$toast("请输入驳回原因");
          return;
        }
      }

      if (formData.id) {
        this.editOrderPayment();
      } else {
        this.addOrderPayment();
      }
    },

    editOrderPayment() {
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      editOrderPayment(this.formData).then((res) => {
        if (res.result) {
          toast.clear();
          this.$toast.success(res.message);
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message);
        }
      });
    },

    addOrderPayment() {
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      addOrderPayment(this.formData).then((res) => {
        if (res.result) {
          toast.clear();
          this.$toast.success(res.message);
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message);
        }
      });
    },

    // 返回
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .item {
        margin-bottom: 50px;
      }
      .input_box,
      .select_box {
        margin-bottom: 30px;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
      .warehouse {
        width: 560px;
        margin: auto;
        text-align: left;
      }
      .upload_box {
        width: 300px;
        height: 300px;
        margin: auto;
        border: 2px dashed #d9d9d9;
        position: relative;
        overflow: hidden;
        background: #ffffff;
        .no {
          width: 100%;
          height: 100%;
          position: relative;
          /deep/ .van-uploader,
          /deep/ .van-uploader__wrapper,
          /deep/ .van-uploader__upload {
            width: 100%;
            height: 100%;
            margin: auto;
          }
          .uploadInput {
            position: absolute;
            width: 100%;
            height: 100%;
            opacity: 0;
            z-index: 1001;
          }
        }
        .del-icon {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 0;
          height: 0;
          border-top: 30px solid transparent;
          border-right: 30px solid #ff0000;
          border-bottom: 30px solid red;
          border-left: 30px solid transparent;
          color: #fff;
          font-size: 24px;
        }
      }
    }
  }
}
</style>